import { Button, useTheme } from '@/components/health-ui';
import { Moon, Sun } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Sun/Moon dark-mode toggle, for the app header.
 *
 * `className` is merged rather than fixed so the mobile top bar can meet the
 * 44px touch target; the default keeps the sidebar's `size-8`.
 */
export function ThemeToggle({
  className,
}: {
  className?: string;
} = {}): React.JSX.Element {
  const { toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('relative size-8 shrink-0', className)}
      aria-label="Toggle dark mode"
      data-testid="theme-toggle"
      onClick={toggleTheme}
    >
      <Sun className="rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
